export const intermediateText = [
    ['Первые преимущества работы в\u00A0НИПИГАЗе расшифрованы. Поздравляем!',
        'Можешь начать карьеру уже сейчас:',
        'Или продолжай узнавать о преимуществах и в конце получи шанс выиграть приз!'
    ],
    ['Ты еще больше открываешь для себя НИПИГАЗ.',
        'Можешь начать карьеру уже сейчас:',
        'Или продолжай узнавать о преимуществах и участвуй в\u00A0розыгрыше! До победы осталось всего 2 уровня.']
]
